if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          if (target?.addPreProcessCallback) {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          }
        });
      }

      hide(preventFocus = false) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart?.setActiveElement) cart.setActiveElement(this.openedBy);
        if (this.modalContent) this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      async show(opener) {
        if (!opener || !this.modalContent) return;

        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading__spinner');
        spinner?.classList.remove('hidden');

        try {
          const productUrl = opener.getAttribute('data-product-url');
          if (!productUrl) throw new Error('Quick Add product URL is missing.');

          const response = await fetch(productUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`Quick Add request failed: ${response.status}`);

          const responseText = await response.text();
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector('product-info');
          if (!productElement) throw new Error('Quick Add product content was not returned.');

          this.preprocessHTML(productElement);
          HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

          if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init();
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          super.show(opener);
        } catch (error) {
          console.error('Mana Rush Quick Add:', error);
          window.location.assign(opener.getAttribute('data-product-url') || '/collections/all');
        } finally {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          spinner?.classList.add('hidden');
        }
      }

      preprocessHTML(productElement) {
        if (!productElement || !this.modalContent) return;

        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient') {
            this.modalContent.classList.add(classApplied);
          }
        });

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement?.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        productElement?.querySelector('pickup-availability')?.remove();
        productElement?.querySelector('product-modal')?.remove();
        productElement?.querySelectorAll('modal-dialog').forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement?.dataset.section;
        if (!sectionId) return;

        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(sectionId)) {
            productElement.setAttribute(attribute.name, attribute.value.replaceAll(sectionId, newId));
          }
        });
        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement?.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((item) => item.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement?.querySelector('.product');
        if (!product?.classList.contains('product--columns')) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let sizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) sizes = sizes.replace('715px', '605px');
        if (product.classList.contains('product--small')) sizes = sizes.replace('715px', '495px');
        mediaImages.forEach((image) => image.setAttribute('sizes', sizes));
      }
    }
  );
}
